import React from "react";
import dayjs from "dayjs";
import {Skeleton} from "antd";
import {History} from "lucide-react";
import {useTranslation} from "react-i18next";
import "./OrderHistoryRange.scss";

export const ORDER_HISTORY_RANGE_MIN = 0;
export const ORDER_HISTORY_RANGE_MAX = 90;

// null means the whole order history ("All time")
export const normalizeOrderHistoryRange = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const days = Math.round(Number(value));
    if (!Number.isFinite(days)) return null;
    return Math.min(ORDER_HISTORY_RANGE_MAX, Math.max(ORDER_HISTORY_RANGE_MIN, days));
};

const getRangeTone = (days) => {
    if (days === null) return 'long';
    if (days === 0) return 'none';
    if (days <= 10) return 'short';
    if (days <= 30) return 'month';
    if (days <= 60) return 'two-months';
    return 'long';
};

const OrderHistoryRange = ({value, compact = false}) => {
    const {t} = useTranslation();

    // undefined = data not loaded yet; null is a real value ("All time")
    if (value === undefined) {
        return (
            <Skeleton.Button
                active
                className={`order-history-range__skeleton${compact ? ' order-history-range__skeleton--compact' : ''}`}
            />
        );
    }

    const days = normalizeOrderHistoryRange(value);
    const tone = getRangeTone(days);

    let title = t("pages.user.profile.orderHistoryRange.all");
    let hint = t("pages.user.profile.orderHistoryRange.allHint");
    if (days === 0) {
        title = t("pages.user.profile.orderHistoryRange.none");
        hint = t("pages.user.profile.orderHistoryRange.noneHint");
    } else if (days !== null) {
        title = t("pages.user.profile.orderHistoryRange.days", {count: days});
        hint = t("pages.user.profile.orderHistoryRange.since", {
            date: dayjs().subtract(days, 'day').format('DD.MM.YYYY'),
        });
    }

    return (
        <div className={`order-history-range__content order-history-range__content--${tone}${compact ? ' order-history-range__content--compact' : ''}`}>
            <span className="order-history-range__icon"><History size={compact ? 13 : 16}/></span>
            <span className="order-history-range__text">
                <span className="order-history-range__title">{title}</span>
                {hint && <span className="order-history-range__hint">{hint}</span>}
            </span>
        </div>
    );
};

export default OrderHistoryRange;
